import { HttpClient, HttpEvent, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class FilesDraftService {

  private apiUrl = environment.API_URL;

  constructor(private http: HttpClient) {}

  uploadDraft(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('nomeArquivo', file.name);

    const req = new HttpRequest('POST', `${this.apiUrl}/minio-v1/files/draft`, formData, {
      responseType: 'text' as any,
      reportProgress: true
    });

    return this.http.request(req).pipe(
      filter((event: HttpEvent<any>): event is HttpResponse<any> => event instanceof HttpResponse),
      map((event: HttpResponse<any>) => event.body as string)
    );
  }
}

